<i-button [styleClass]="'blue'" [text]="'Filtrer'" [icon]="'bi bi-funnel-fill'" (click)="toggleFiltersDialog()"
    [count]="hasActiveFilters()  && activeFilters().length ? activeFilters().length : undefined"></i-button>

<p-dialog [(visible)]="isFiltersDialogOpen" [header]="'Filtrer sur les champs'" [blockScroll]="true"
    [style]="{width: '60dvw'}">
    <div class="table-columns-filter">
        <div style="max-height: 50dvh; overflow-y: auto;">
            @for(activeFilter of activeFilters(); track activeFilter.field; let last=$last) {

            <div class="d-flex align-items-center" [class.mb-2]="!last">
                <div>
                    <p-dropdown [options]="getAvailableFieldsToFilterOptions(activeFilter.field)" [appendTo]="'body'"
                        [(ngModel)]="activeFilter.field" optionLabel="label" optionValue="value"
                        (onChange)="resetActiveFilterValue(activeFilter)" [style]="{width: '300px'}"></p-dropdown>
                </div>
                <div>
                    @if(getActiveFilterFieldType(activeFilter) !== 'enum' ) {
                    <p-dropdown [options]="getOperatorTypeOptions(activeFilter.field)" [appendTo]="'body'"
                        [(ngModel)]="activeFilter.operator"
                        (onChange)="onActiveFilterOperatorChange($event, activeFilter)"
                        [style]="{width: '200px'}"></p-dropdown>
                    }@else {
                    @if(getActiveFilterMultiSelection(activeFilter)) {
                    <p-dropdown [options]="[{label: 'Parmis', value: 'contains'}]" [appendTo]="'body'"
                        [style]="{width: '200px'}" [autoDisplayFirst]="true" [disabled]="true"></p-dropdown>
                    }@else {
                    <p-dropdown [options]="[{label: 'Est', value: 'Est'}]" [appendTo]="'body'" [disabled]="true"
                        [autoDisplayFirst]="true" [style]="{width: '200px'}"></p-dropdown>
                    }
                    }
                </div>


                @switch (getActiveFilterFieldType(activeFilter)) {
                @case ('string') {
                <div>
                    <input type="text" pInputText [(ngModel)]="activeFilter.value" />
                </div>
                }
                @case('number') {
                @if(activeFilter.operator !== 'zero' && activeFilter.operator !== 'isEmpty' && activeFilter.operator !==
                'isNotEmpty') {
                <div>
                    <input type="number" pInputNumber [(ngModel)]="activeFilter.value" />
                </div>

                }
                }
                @case('date') {
                <div>
                    <p-calendar [(ngModel)]="activeFilter.value" dateFormat="dd/mm/yy" [appendTo]="'body'"></p-calendar>
                </div>
                }
                @case('enum') {
                <div>
                    @if(getActiveFilterMultiSelection(activeFilter)) {
                    <p-multiSelect [options]="getColumnOptions(activeFilter)" [appendTo]="'body'"
                        [(ngModel)]="activeFilter.value" [style]="{width: '300px'}"
                        (onChange)="onFilterValueChange(activeFilter,$event)" [filter]="true"
                        [disabled]="!getColumnOptions(activeFilter).length" [filterBy]="'label'"></p-multiSelect>
                    }@else {
                    <p-dropdown [options]="getColumnOptions(activeFilter)" [appendTo]="'body'"
                        [(ngModel)]="activeFilter.value" [style]="{width: '300px'}"
                        (onChange)="onFilterValueChange(activeFilter,$event)" [filter]="true"
                        [disabled]="!getColumnOptions(activeFilter).length" [filterBy]="'label'"></p-dropdown>
                    }

                </div>
                @if(getColumnOptions(activeFilter).length) {
                <span>
                    <idel-infos-chip [info]="'Vous ne voyez que les éléments présents'"></idel-infos-chip>
                </span>
                }@else {
                <span [pTooltip]="'Aucun élément disponible pour ce filtre'"
                    style="color: var(--orange-400); font-size: 1.5rem;" class="ms-2">
                    <i class="bi bi-exclamation-diamond-fill"></i>
                </span>
                }
                }}
                @if(activeFilters().length > 1) {
                <span class="ms-auto">
                    <i-button [styleClass]="'red'" [text]="'Retirer'" [icon]="'bi bi-trash-fill'"
                        (click)="onDeleteActiveFilter(activeFilter)"></i-button>

                </span>

                }
            </div>
            }
        </div>
        <div class="d-flex flex-row align-items-center justify-content-end gap-1 mt-3">
            <div>
                <i-button [styleClass]="'green w-100'" [text]="'Ajouter un filtre'" [icon]="'bi bi-plus-circle-fill'"
                    [disabled]="!canAddFilter()" (click)="onAddNewActiveFilter()"></i-button>

            </div>
            <div>
                <i-button [styleClass]="'red w-100'" [text]="'Réinitialiser'" [icon]="'bi bi-arrow-counterclockwise'"
                    (click)="onResetFilters()"></i-button>
            </div>
            <div>
                <i-button [styleClass]="'blue w-100'" [text]="'Filtrer'" [disabled]="!canFilter()"
                    (click)="onFilterClick()"></i-button>
            </div>
        </div>
    </div>
</p-dialog>